<template>
    <div>
        <router-view @refresh="refresh()"></router-view>
        <header class="content-header">
            <div class="wrapper">

                <div>
                    <h1>Profile</h1>
                    <p>Gestion des profile</p>
                </div>

                <div class="actions">
                    <ul>
                        <!--<li><button><span>Importer</span></button></li>-->
                        <li><button @click="exportFile()"><span>Export xls</span></button></li>
                        <li><button class="bt-primary" @click="create()"><i class="icon icon-icon_person-add"></i><span>Créer</span></button></li>
                    </ul>
                </div>

            </div>
        </header>
        <div class="content-body">

            <section>
            <div class="search">
                <div><input type="text" placeholder="Recherche" v-model="query"/></div>
                <!--
                <div>
                    <ul>
                        <li><button><span>Menu 1</span></button></li>
                        <li><button><span>Menu 1</span></button></li>
                        <li><button><span>Menu 1</span></button></li>
                    </ul>
                </div>
                -->
            </div>

            <h2 class="datagrid-results"><strong>{{paginator.total}}</strong> Résultats trouvés</h2>

            <div class="datagrid" :class="paginator.listing">
                <div class="datagrid-header">
                    <div>
                        <div></div>
                        <div class="picture"></div>
                        <div v-bind:class="[ paginator.sort == 'firstname' ? 'active' : '', paginator.order ]">
                            <span data-sort="firstname" @click="setOrder($event)">Prénom</span>
                        </div>
                        <div v-bind:class="[ paginator.sort == 'lastname' ? 'active' : '', paginator.order ]">
                            <span data-sort="lastname" @click="setOrder($event)">Nom</span>
                        </div>
                        <div v-bind:class="[ paginator.sort == 'email' ? 'active' : '', paginator.order ]">
                            <span data-sort="email" @click="setOrder($event)">Email</span>
                        </div>
                        <div><span>Scope</span></div>
                        <div><span>Statut</span></div>
                        <div class="actions"></div>
                        <div></div>
                    </div>
                </div>
                <div class="datagrid-body">
                    <div v-for="item in resources" @dblclick="edit(item.id)">
                        <div></div>
                        <div class="picture">
                            <figure>
                                <i v-if="!item.picture" class="icon icon-icon_person"></i>
                                <img v-if="item.picture" :src="item.picture.url+'/fit/100x100'"/>
                            </figure>
                        </div>
                        <div data-field="firstname"><strong>{{ item.firstname }}</strong></div>
                        <div data-field="lastname"><strong>{{ item.lastname }}</strong></div>
                        <div data-field="email">{{ item.email }}</div>
                        <div data-field="scope"><scopes v-model="item.scopes" v-if="item.scopes"></scopes></div>
                        <div class="status"><active v-model="item.user.active" v-if="item.user"></active></div>
                        <div class="actions">
                            <ul>
                                <li v-if="item.policies && item.policies.delete"><button @click="remove(item.id)"><i class="icon icon-icon_delete"></i></button></li>
                                <li v-if="item.policies && item.policies.update"><button @click="edit(item.id)"><i class="icon icon-icon_pencil"></i></button></li>
                            </ul>
                        </div>
                        <div></div>
                    </div>
                </div>
            </div>
            </section>

            <component-paginator v-model="paginator" v-on:refresh="refresh"></component-paginator>

        </div>
    </div>
</template>
<script>
    import PersonService from './PersonService.js';
    import Index from '../../layouts/Index.vue';

    export default {
        extends: Index,
        data () {
            return {
            }
        },
        mounted: function(){
            this.refresh()
        },
        methods: {
            getResource: function(){
                return {name: 'person', api: PersonService};
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/modules/person/Index.vue